import LTR from "@brand-icons/ploom/shopping-bag/shopping-bag-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ShoppingBagIcon = iconFactory("ShoppingBagIcon", LTR);
